module.exports = __webpack_public_path__ + "static/img/buy_pt.129a4436.png";